import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    ArrayField,
    SingleFieldList,
    ChipField,
    FunctionField,
} from 'react-admin';
import Filter from './filter';
import Pagination from '../pagination';
import { CustomLink } from '../fields';
import { Subcategory } from '../subcategory';

export default props => {
    return (
        <List
            title="Report"
            filters={<Filter permissions={props.permissions}/>}
            sort={{field: 'id', order: 'DESC'}}
            pagination={<Pagination/>}
            perPage={40}
            bulkActionButtons={false}
            {...props}
        >
            <Datagrid>
                <CustomLink label="Id"/>
                <ReferenceField label="Provider ID" source="provider_id" reference="users" link={(record, reference) => `/providers/${record.provider_id}`} >
                    <FunctionField render={record => `${record.first_name} ${record.last_name}`}/>
                </ReferenceField>
                <ReferenceField label="Brand name" source="provider_id" reference="users" link={false}>
                    <TextField source="brand"/>
                </ReferenceField>
                <ReferenceField label="Artist ID" source="artist_id" reference="artists">
                    <TextField source="id"/>
                </ReferenceField>
                <ReferenceField label="Artist Name" source="artist_id" reference="artists" link={false}>
                    <FunctionField render={record => `${record.first_name} ${record.last_name}`}/>
                </ReferenceField>
                <TextField label="Content Name" source="name"/>
                <ReferenceField source="art_type_id" reference="art-types" link={false}>
                    <TextField source="name"/>
                </ReferenceField>
                <ArrayField source="categories">
                    <SingleFieldList linkType={false}>
                        <ReferenceField reference="categories" source="id">
                            <ChipField source='name'/>
                        </ReferenceField>
                    </SingleFieldList>
                </ArrayField>
                <Subcategory label="Sub-categories" />
                <TextField label="Product Page views" source="views_product.length"/>
                <TextField label="Likes" source="likes.length"/>
                <TextField label="Favorites" source="favorite_products.length"/>
            </Datagrid>
        </List>
    );
}